<template>
	<div>
    <div v-if="is_load" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
    	<div class="px-4" v-if="error != ''">
      	<ErrorMessage :message="error" />
    	</div>
      <template v-else>
      	<!-- NAVBAR -->
      	<template v-if="scroll_position > 150 || !reservation.id">
					<wrapper-mobile-view>
						<div class="w-100 bg-white py-3 px-4" :class="{'border-b-semi-grey':scroll_position > 50}">
							<div class="w-100">
								<div class="row">
									<div class="col-1 align-self-center">
										<router-link :to="`/${getMerchant.code}/`" class="d-inline-grid">
	                    <img src="../../../assets/img/icon/back.png" class="mt-1" width="20">
	                  </router-link>
									</div>
									<div class="col-10 align-self-center">
										<p class="mb-0 body-1-2">{{general.name}}</p>
									</div>
								</div>
							</div>
						</div>
					</wrapper-mobile-view>
					<block :height="57" />
				</template>
				<!-- <template > -->
				<template v-if="reservation.id">
					<div class="w-100 bg-green p-4 mb-4">
						<div class="row no-gutters pb-3 m-0">
		          <div class="col-1 align-self-center">
		            <router-link :to="`/${getMerchant.code}/`" class="d-inline-grid">
		              <img src="../../../assets/img/icon/back-white.svg" class="mt-1" width="18">
		            </router-link>
		          </div>
		          <div class="col-11 align-self-center">
		            <p class="mb-0 ml-2-back body-1-2 text-truncate text-white">{{general.name}}</p>
		          </div>
		        </div>
						<div class="w-100 bg-white radius-6 p-3">
							<div class="row no-gutters">
								<div class="col-2">
									<img :src="getMerchant.image_url" :alt="getMerchant.name" class="w-100">
								</div>
								<div class="col-10">
									<div class="px-3">
										<p class="mb-1 body-1-2">{{getMerchant.name}}</p>
										<div class="row no-gutters">
											<div class="col-4">
												<p class="body-3-3-1 mb-0">{{$t('hotel.guests.guests')}}</p>
											</div>
											<div class="col-8">
												<p class="body-3-1 mb-0 text-truncate">: {{reservation.booked_by.name}}</p>
											</div>
										</div>
										<div class="row no-gutters">
											<div class="col-4">
												<p class="body-3-3-1 mb-0">{{$t('hotel.rooms-type')}}</p>
											</div>
											<div class="col-8">
												<p class="body-3-1 mb-0 text-truncate">: {{reservation.room_type.name}}</p>
											</div>
										</div>
										<div class="row no-gutters">
											<div class="col-4">
												<p class="body-3-3-1 mb-0">{{$t('hotel.date.check-in')}}</p>
											</div>
											<div class="col-8">
												<p class="body-3-1 mb-0 text-truncate">: {{$formatDate(reservation.arrival_date)}}</p>
											</div>
										</div>
										<div class="row no-gutters">
											<div class="col-4">
												<p class="body-3-3-1 mb-0">{{$t('hotel.date.check-out')}}</p>
											</div>
											<div class="col-8">
												<p class="body-3-1 mb-0 text-truncate">: {{$formatDate(reservation.departure_date)}}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>

				<!-- LIST -->
				<div class="">
					<div class="border-bottom mb-4 pb-2">
						<div class="w-100 mb-3 px-4" v-if="general.slider.length == 1" style="height: 189px !important;">
		          <img :src="general.slider[0].image_url" class="img-fit" height="189">
		        </div>
		    		<div v-if="general.slider.length > 1" class="mb-4">
			    		<flickity ref="flickity" :options="$freeScrollSliderOption">
					      <div class="carousel-cell w-93 mr-2" 
					      	:id="index" 
					      	v-for="(slide, index) in  general.slider" 
					      	:class="{'pl-4':index == 0, 'pr-4':index == general.slider.length - 1}">
					        <div class="w-100" style="height: 189px !important;">
					          <img :src="slide.image_url" class="img-fit radius-6" height="189">
					        </div>
					      </div>
					    </flickity>
					  </div>
					</div>
				</div>
				<div class="px-4">
					<div class="w-100 mb-5" v-for="group in general.group">
						<p class="sub-heading-1-1 mb-0">{{group.title}}</p>
						<p class="body-2-2-1 mb-3">{{group.subtitle}}</p>
						<!-- SLIDER -->
					<!-- 	<div class="w-100 mb-3" v-if="group.upselling_product_group.slider.length == 1" style="height: 189px !important;">
		          <img :src="group.upselling_product_group.slider[0].image_url" class="img-fit" height="189">
		        </div>
		    		<div v-if="group.upselling_product_group.slider.length > 1" class="pl-3 mb-4">
			    		<flickity ref="flickity" :options="$freeScrollSliderOption">
					      <div class="carousel-cell w-90 mr-3" :id="slide.id" v-for="slide in  group.upselling_product_group.slider">
					        <div class="w-100" style="height: 189px !important;">
					          <img :src="slide.image_url" class="img-fit radius-6" height="189">
					        </div>
					      </div>
					    </flickity>
					  </div> -->
						<div class="mb-3" v-for="product in group.upselling_product">
							<VoucherItem :data="product"></VoucherItem>
						</div>
					</div>
				</div>
				<template v-if="getVoucherOrderTotalQty>0">
					<block :height="57" />
					<wrapper-mobile-view fixed_position="bottom">
						<div class="w-100 bg-white py-3 px-4">
							<div class="radius-12 bg-green w-100 px-3 py-2 cursor-pointer" @click="$router.push(`/${getMerchant.code}/upselling/cart`)">
		            <div class="row no-gutters">
		              <div class="col-5 no-ws align-self-center">
		                <img 
		                	src="../../../assets/img/icon/svg-buy.svg" 
		                	width="20" 
		                	class="d-inline-block align-middle">
		                <p class="text-white ml-2 mb-0 body-2-4 d-inline-block align-middle">
		                	{{getVoucherOrderTotalQty > 1 ? `${getVoucherOrderTotalQty} Vouchers` : `${getVoucherOrderTotalQty} Voucher`}}
		                </p>
		              </div>
		              <div class="col-7 text-right align-self-center">
		                <p class="text-white mb-0 body-3-1">
		                	{{$t('hotel.concierge.fitur.total-pay')}}
		                </p>
		                <p class="text-white mb-0 body-1-1">{{$formatCurrency(getVoucherOrderTotal)}}</p>
		              </div>
		            </div>
		          </div>
		        </div>
					</wrapper-mobile-view>
					</template>
				</template>
			</template>
		</div>
</template>
<script>
	import VoucherItem from '@/components/hotel/upselling/VoucherItem'
	import {get} from '@/services/index.js'
	import {mapGetters,mapMutations} from 'vuex'
	import moment from 'moment'
  import Flickity from 'vue-flickity';

	export default{
		components:{
			VoucherItem,
			Flickity
		},
		metaInfo(){
      return {
        title: this.general.name ? this.general.name : 'Voucher',
        titleTemplate: this.getMetaTitleTemplate
      }
    },
		data(){
			return{
				is_load: true,
				error : '',
				general: {},
				reservation: {},
				scroll_position: 0
			}
		},
		computed:{
			...mapGetters(['getMerchant','getMetaTitleTemplate','getVoucherOrderTotalQty','getVoucherOrderTotal','getUpsellRef','getVoucherPageModule']),
			group_id(){
				return this.$route.params.id
			}
		},
		mounted(){
			window.addEventListener('scroll', this.updateScroll);
			this.loadFirstData()
		},
		methods:{
			...mapMutations(['setVoucherGroupId','setVoucherPageModule','resetVoucherOrder']),
			loadGroupVoucher(){
				return new Promise((success,fail)=>{
					get("CORE_HOTEL",`upselling/product-group/${this.group_id}`,{
						merchant_id: this.getMerchant.id
					}).then(response=>{
						if(response.data.success){
							this.general = response.data.data
							success()
						}else{
							fail(response.data.message)
						}
					})
				})
			},
			loadReservationDetail(){
				return new Promise((success,fail)=>{
					get("CONCIERGE",`reservation/${this.getUpsellRef.reservation_id}`,{
						merchant_id: this.getMerchant.id
					}).then(response=>{
						if(response.data.success){
							this.reservation = response.data.data
							success()
						}else{
							fail(response.data.message)
						}
					})
				})
			},
			loadFirstData(){
				this.is_load = true
				this.error = ''
				this.setVoucherGroupId(this.group_id)
				let func_exc = [this.loadGroupVoucher()] 
												
				if(this.getUpsellRef.reservation_id != ''){
					func_exc.push(this.loadReservationDetail())
				}

				let current_route = this.$route.name
				console.log("🚀 ~ loadFirstData ~ current_route:", current_route)

				if(this.getVoucherPageModule != current_route){
					this.resetVoucherOrder()
				}
				
				Promise.all(func_exc).catch(err=>{
					this.error = err
				}).finally(()=>{
					this.is_load = false
				})
			},
			updateScroll() {
        this.scroll_position = window.scrollY
      },
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/hotel/upselling/GroupVoucher.vue